import axios from "axios";
import { baseURL } from "../../../utils/api";

function createAxios() {
  const token = JSON.parse(localStorage.getItem("profile"))?.token;

  return axios.create({
    baseURL: `${baseURL}`,
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${token && token.access}`,
    },
  });
}

export const filterCourse = (payload) => async (dispatch) => {
  try {
    let API = createAxios();
    const { data } = await API.get("/course" + payload);
    return data;
  } catch (e) {
    console.error("filterCourse error:", e);
    return { success: false, message: e.response?.data?.message || e.message || "Failed to fetch courses" };
  }
};

export const getUpcomingClassForStudent = (sid) => async (dispatch) => {
  try {
    let API = createAxios()
    const { data } = await API.get(`student/upcomingClass/${sid}`)
    return data
  } catch (error) {
    console.error("getUpcomingClassForStudent error:", error);
    return { success: false, message: error.response?.data?.message || error.message || "Failed to load upcoming classes" };
  }
}

export const getStudentDashNums = (sid) => async (dispatch) => {
  try {
    let API = createAxios()
    const { data } = await API.get(`student/getDashNums/${sid}`)
    return data
  } catch (error) {
    console.error(error)
    return error.response.message;
  }
}

export const newStudent = (userId) => async (dispatch) => {
  try {
    let API = createAxios();
    const { data } = await API.post(`/student/new/${userId}`)
    return data
  } catch (error) {
    console.error(error)
  }
}

export const getStudentData = (uid) => async (dispatch) => {
  try {
    let API = createAxios();
    // Use GET on /student/myDetails (auth middleware handles ID)
    const { data } = await API.get(`/student/myDetails`);
    return data;
  } catch (e) {
    console.error("getStudentData error:", e);
    // Return empty array or specific error structure to handle downstream checks
    return e.response?.data || [];
  }
};


export const getStudentDetailById = (uid) => async (dispatch) => {
  try {
    let API = createAxios()
    const { data } = await API.get(`/student/${uid}`)
    return data
  } catch (error) {
    console.error(error)
  }
}

export const updateStudentProfile = (payload) => async (dispatch) => {
  try {
    let API = createAxios();

    // If payload is FormData, unset Content-Type so browser sets it with boundary
    const config = (payload instanceof FormData)
      ? { headers: { "Content-Type": undefined } }
      : {};

    const { data } = await API.post("student/updateProfile", payload, config);
    return data;
  } catch (e) {
    console.error("updateStudentProfile error:", e);
    return e.response?.data || { message: "Update failed" };
  }
};

export const bookSlot = (payload) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.post("/session/bookSession", payload);
    return data;
  } catch (e) {
    console.error("bookSlot error:", e);
    return { success: false, message: e.response?.data?.message || e.message || "Failed to book session" };
  }
};

export const reSchedule = (payload) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.post("/session/reschedule", payload);
    return data;
  } catch (e) {
    console.error("reSchedule error:", e);
    return { success: false, message: e.response?.data?.message || e.message || "Failed to reschedule session" };
  }
};

export const makePayment = (payload) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.post("/student/payment/razorpay", payload);
    return data;
  } catch (e) {
    console.error("makePayment error:", e);
    return {
      success: false,
      message: e.response?.data?.message || e.response?.data?.error || "Payment initialization failed"
    };
  }
};

export const verifyPayment = (payload) => async (dispatch) => {
  try {
    let API = createAxios();
    const { data } = await API.post("/student/payment/verification", payload);
    return data;
  } catch (e) {
    console.error("verifyPayment error:", e);
    return {
      success: false,
      message: e.response?.data?.message || e.response?.data?.error || "Payment verification failed"
    };
  }
};

export const bookTrial = (payload) => async (dispatch) => {
  try {
    let API = createAxios();
    const { data } = await API.post("/student/bookTrial", payload);
    return data;
  } catch (e) {
    console.error("bookTrial error:", e);
    return { success: false, message: e.response?.data?.message || "Trial booking failed" };
  }
};

export const getCurrentTeachers = (stuid) => async (dispatch) => {

  try {
    let API = createAxios();
    const { data } = await API.get(`/student/currentTeachers/${stuid}`);
    return data;
  } catch (e) {
    console.error(e);
    return e.response.message;
  }
};
export const cancelVideoSession = (payload) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.post("/student/cancelSession", payload);
    // dispatch({ type: "Create_Course", payload: { ...data } });
    return data;
  } catch (e) {
    console.error(e);
    return e.response.message;
  }
};
export const updateSessionRefund = (payload) => async (dispatch) => {
  try {
    let API = createAxios();

    const { data } = await API.post("/student/updateRefund", payload);

    // dispatch({ type: "Create_Course", payload: { ...data } });
    return data;
  } catch (e) {
    console.error(e);
    return e.response.message;
  }
};



